import { render, staticRenderFns } from "./InsuranceStore.vue?vue&type=template&id=edee2980&"
import script from "./InsuranceStore.vue?vue&type=script&lang=js&"
export * from "./InsuranceStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports